<!-- 基本资料 -->
<template>
  <div class="bar_blog">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">基本资料</div>
      </el-col>
      <el-col :span="12">
        <!--<div class="grid-content bg-purple title2">登录时间：<em>2017-01-03 15:27:39</em></div>-->
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">用户头像：</div></el-col>
      <el-col :span="5">
        <div class="grid-content bg-purple-light in">
          <el-upload
            class="avatar-uploader"
            action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS"

            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="formInline.file" :src="formInline.file" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon el-border"></i>
          </el-upload>
        </div>
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">昵称：</div></el-col>
      <el-col :span="5">
        <div class="grid-content bg-purple-light in">
          <el-input v-model="formInline.name" maxLength='15' placeholder="请输入昵称"></el-input>
        </div>
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">性别：</div></el-col>
      <el-col :span="5">
        <div class="grid-content bg-purple-light in">
          <div class="sex">
            <el-radio v-model="formInline.sex" label="1">男</el-radio>
            <el-radio v-model="formInline.sex" label="0">女</el-radio>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">感情状况：</div></el-col>
      <el-col :span="5">
        <div class="grid-content bg-purple-light in">
          <el-select v-model="formInline.emotionStatus" placeholder="状况选择">
            <el-option :label="val.affectionName" :value="val.code" v-for="(val,index) in emotion" :key="index"></el-option>
          </el-select>
        </div>  
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">星座：</div></el-col>
      <el-col :span="5">
        <div class="grid-content bg-purple-light in">
          <el-select v-if="loading" v-model="formInline.constellation" placeholder="星座选择">
            <el-option v-for="(item,index) in constellation" :label="item.constellationName" :value="item.code" :key="index">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">出生日期：</div></el-col>
      <el-col :span="5">
        <div class="grid-content bg-purple-light in">
          <div class="block">
            <el-date-picker
              v-model="formInline.dateBirthStr"
              type="date"
              placeholder="选择日期时间"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </div>  
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">家乡地址：</div></el-col>
      <el-col :span="15">
        <div class="city">
          <el-select v-model="formInline.homeProvinceCode" placeholder="省" @change="changeProvince">
            <el-option v-for="(item,index) in hometown" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
          <el-select v-model="formInline.homeCityCode" placeholder="市" @change="changeCity">
            <el-option v-for="(item,index) in cityArr" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
          <el-select v-model="formInline.homeAreaCode" placeholder="县、乡">
            <el-option v-for="(item,index) in countyArr" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>

    <el-row class="repeatable" v-if="loading">
      <el-col :span="3"><div class="grid-content bg-purple name">职业：</div></el-col>
      <el-col :span="20">
        <div class="block">
          <el-cascader
            :options="profession"
            v-model="selectedOptions"
            change-on-select
            @change="handleChange">
          </el-cascader>
        </div>
      </el-col>
    </el-row>

    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">语言能力：</div></el-col>
      <el-col :span="21">
        <el-select v-model="languagesArrNew" multiple placeholder="请选择">
          <el-option
            v-for="item in languageArr"
            :key="item.code"
            :label="item.languageName"
            :value="item.code">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">现居住地：</div></el-col>
      <el-col :span="15">
        <div class="city">
          <el-select v-model="formInline.currentProvinceCode" placeholder="省" @change="changeProvinceNow">
            <el-option v-for="(item,index) in hometownNow" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
          <el-select v-model="formInline.currentCityCode" placeholder="市" @change="changeCityNow">
            <el-option v-for="(item,index) in cityArrNow" :label="item.label" :value="item.value"  :key="index"></el-option>
          </el-select>
          <el-select v-model="formInline.currentAreaCode" placeholder="县、乡">
            <el-option v-for="(item,index) in countyArrNow" :label="item.label" :value="item.value"  :key="index"></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row class="repeatable" v-if="labelShowArr.length>0">
      <el-col :span="4"> </el-col>
      <el-col :span="20" style="margin: 10px" >
        <div class="language_competence">
          <span class="entrance" v-for="(item,index) in labelShowArr"  :key="index">
            <span class="entrance-border" @click="closeLabel(item,index)"></span>
            <span class="entrance-close" @click="closeLabel(item,index)">x</span>
            {{item.label}}/{{item.labelName}}
          </span>
        </div>
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">个人标签：</div></el-col>
      <el-col :span="15">
        <el-cascader
            :options="labelArr"
            v-model="selectLabelArr"
            change-on-select
            placeholder="增加标签"
            @change="handleChangeLabel">
          </el-cascader>
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">个性签名：</div></el-col>
      <el-col :span="15">
        <div class="grid-content bg-purple-light in">
          <el-input v-model="formInline.description" placeholder="请输入个性签名描述" maxLength="1000"></el-input>
        </div>
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">个人介绍：</div></el-col>
      <el-col :span="15">
        <div class="grid-content bg-purple-light in">
          <el-input
            type="textarea"
            autosize
            maxLength="1000"
            placeholder="请输入个人介绍描述"
            v-model="formInline.signature"
            :autosize="{ minRows: 3, maxRows: 5}">
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="3"><div class="grid-content bg-purple name">我的故事：</div></el-col>
      <el-col :span="15">
        <div class="grid-content bg-purple-light in">
          <el-input
            type="textarea"
            autosize
            maxLength="1000"
            placeholder="请输入我的故事描述"
            v-model="formInline.userStory"
            :autosize="{ minRows: 3, maxRows: 5}">
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row class="repeatable">
      <el-col :span="24">
        <el-button class="btn" type="primary" @click="submitBtn()">保存资料</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<!--JS-->
<script>
  import {getUserDetail,getCityData,updateUserDetailForIndex} from "api/apis";
  import photoPage from './photoPage'

  import $ from "jquery";
  export default {
    data() {
      return {
        imgHead:{
          code: localStorage.getItem("pbw_user_pc_uid"),
          loginType: '1',
          loginKey: localStorage.getItem("pbw_user_pc_loginKey"),
          secretKey: localStorage.getItem("pbw_user_pc_secretKey"),
        },
        bar_show:1,
        nickname:'', //昵称
        sex: "1", //性别
        imageUrl: "", //图片路径
        birthdate: '', //出生日期
        selectedOptions: [], //职业
        Personality:'', //个性说明
        introduction:'', //个人介绍
        MyStory: '', //我的故事
        emotion:[], //感情返回对象
        constellation:[], //星座返回对象
        result: [], //城市返回对象
        hometown: [],
        cityArr: [],//市
        countyArr: [],//地区
        hometownNow: [],//地区
        cityArrNow: [],//市
        countyArrNow: [],//地区
        labelArr:[],//个人标签
        selectLabelArr:[],
        labelShowArr:[],//个人标签展示
        languagesArrNew:[],//语言
        loading:false,
        careersOption:[],//职业初始数组
        labelInit:[],//个人标签初始数组
        
        languageArr:[],
        formInline: {
          name: '',//用户姓名
          sex: '',//性别
          file: '',//用户头像
          careers: '',//职业
          dateBirthStr: '',//出生日期
          constellation: '',//星座
          homeProvinceCode: '',//家乡省id
          homeCityCode: '',//家乡市id
          homeAreaCode: '',//家乡区        
          currentProvinceCode: '',//现局地市
          currentAreaCode: '',//现局地省
          currentCityCode:'',
          emotionStatus: '',//情感code
          languages: '',//语言能力
          signature: '',//个性说明签名
          labels: '',//个人签名
          description: '',//个人说明
          userStory: '',//个人故事
          uid: localStorage.getItem('pbw_user_pc_uid'),
          profession:[],
          is_loading: false,
        },
      }
    },
    methods: {
      closeLabel (item,index) {//删除个人标签
        this.labelShowArr.shift(index)
        if(this.labelShowArr.length==0){
          this.selectLabelArr = []
        }
      },
      handleChangeLabel(val){//个人标签
        for (let i=0; i<this.labelArr.length; i++) {
          if(this.labelArr[i].value == val[0]){
            let data = {}
            for (let j=0; j<this.labelArr[i].children.length; j++) {
              
              if (this.labelArr[i].children[j].code == val[1]) {
                data = {
                  value: this.labelArr[i].value,
                  label: this.labelArr[i].label,
                  code: this.labelArr[i].children[j].code,
                  labelName: this.labelArr[i].children[j].labelsName,
                }

                for(let t of this.labelShowArr){
                  if(val[1] == t.code){
                    this.$message.warning("您已添加该标签了哦，可选其它个人标签！")
                    return
                  }
                }
                this.labelShowArr.push(data)
              }
            }
          }
        }
      },
      handleAvatarSuccess(res, file) {
        console.log(res,"回传成功")
        this.imageUrl = URL.createObjectURL(file.raw);
        this.formInline.file = res.data.ossFileName
      },
      beforeAvatarUpload(file) {
        // 上传格式判断
        if (!/.(jpg|jpeg|png|bmp|JPG|JPEG|PNG|BPM)$/.test(file.name)) {
          this.$message.error('文件格式只能是jpeg、jpg、PNG、bmp中的一种!')
          return false
        }
        if (file.size > 100 * 1024 * 1024) {
          this.$message.error('文件大小超过限制')
          return false
        }
        const loading = this.$loading({
          lock: true,
          text: '上传中～',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 1500);
      },
      changeCity (val) {
        this.formInline.homeAreaCode = ''
        for(let i=0; i<this.cityArr.length; i++){
          if(this.cityArr[i].value == val){
            this.countyArr = this.cityArr[i].children
          }
        }
      },
      changeProvince (val) {
        this.formInline.homeCityCode = ''
        this.formInline.homeAreaCode = ''
        for(let i=0; i<this.hometown.length; i++){
          if(this.hometown[i].value == val){
            this.cityArr = this.hometown[i].children
          }
        }
      },
      changeProvinceNow (val) {
        this.formInline.currentCityCode = ''
        for(let i=0; i<this.hometownNow.length; i++){
          if(this.hometownNow[i].value == val){
            this.cityArrNow = this.hometownNow[i].children
          }
        }
      },
      changeCityNow (val) {
        this.formInline.currentAreaCode = ''
        for(let i=0; i<this.cityArrNow.length; i++){
          if(this.cityArrNow[i].value == val){
            this.countyArrNow = this.cityArrNow[i].children
          }
        }
      },
      /*职业*/
      handleChange(value) {
        console.log(this.selectedOptions);
      },
      /*用户保存信息*/
      submitBtn(){
        
        this.formInline.careersCode = this.selectedOptions[1]
        let aryLabel = []
        for(let item of this.labelShowArr){
          aryLabel.push(item.code)
        }
        this.formInline.labelsCode = aryLabel.toString()//个人标签
        this.formInline.languagesCode = this.languagesArrNew.toString()//语言

        if (this.formInline.name == "") {//用户名
          this.$message.error("请输入您的用户名！");
          return false;
        }
        if (this.formInline.sex == "") {//性别
          this.$message.error("请选择性别！");
          return false;
        }
        if(this.formInline.dateBirthStr == ''){
          this.$message.error("出生日期不能为空");
          return false;
        } 
        if(this.formInline.homeProvinceCode == '' || this.formInline.homeCityCode == '' || this.formInline.homeAreaCode == ''){
          this.$message.error("请输入您的家乡地址！");
          return false;
        }
        if(this.formInline.currentProvinceCode == '' || this.formInline.currentCityCode == '' || this.formInline.currentAreaCode == ''){
          this.$message.error("请输入您现在居住的地址！");
          return false;
        }
        if(this.formInline.emotionStatus == ''){//情感
          this.$message.error("请选择您的感情状况！");
          return false;
        }
        console.log(this.formInline)
 
        updateUserDetailForIndex(this.formInline).then((res) => {
          if(res.code == '000000'){
            this.$message.success('恭喜您，提交成功！')
          } else {
            this.$message.warning(res.msg)
          }
        })
      },
      getUserInfor(){
        // 获取个人信息
        getUserDetail({uid: localStorage.getItem("pbw_user_pc_uid")}).then((res) => {
          if (res.code == '000000') {
            let objInfor = res.data
            let objInformation = this.formInline
            if(res.data.constellation == 0){
              res.data.constellation = ''
            }
            if(res.data.currentAreaCode == 0){
              res.data.currentAreaCode = ''
              res.data.currentCityCode = ''
              res.data.currentProvinceCode = ''
            }
            if(res.data.homeAreaCode == 0){
              res.data.homeAreaCode = ''
              res.data.homeCityCode = ''
              res.data.homeProvinceCode = ''
            }
            for(let item in objInfor){
              for(let value in objInformation){
                if(item == value){ //将个人信息赋值
                  this.formInline[value] = objInfor[item]
                }
              }
              this.formInline.sex = String(res.data.sex)
              this.formInline.file = res.data.headImg

              if (item == 'currentProvinceCode') { //现居省
                this.changeProvinceNow(res.data.currentProvinceCode)
                this.changeCityNow(res.data.currentCityCode)
              }
              if (item == 'homeProvinceCode') {//家乡省
                this.changeProvince(res.data.homeProvinceCode)//家乡住址
                this.changeCity(res.data.homeCityCode)
              }

              if(item == 'languagesCode'){//语言
                if(objInfor[item]){
                  this.formInline.languages = objInfor[item]
                  this.languagesArrNew = objInfor[item].split(',')
                  this.languagesArrNew = this.languagesArrNew.map(Number)
                  // console.log(this.languagesArrNew,"8888888888")
                }

              }
              if(item == 'careersCode'){//职业
                for (let c of this.careersOption) {
                  if (c.code == objInfor[item]) {
                    this.selectedOptions[0] = c.careerSort
                    this.selectedOptions[1] = c.code
                    // this.is_loading = true
                    console.log(this.selectedOptions,"职业零零落落")
                  }
                }
              }
              if (item == 'labelsCode') {//个人标签
                if(objInfor[item]){
                  let labelNew = objInfor[item].split(',')
                  let data = {}
                  for (let l of this.labelInit) {
                    for (let ln of labelNew) {
                      if (l.code == ln) {
                        data = {
                          value: l.value,
                          label: l.sortName,
                          code: l.code,
                          labelName: l.labelsName,
                        }
                        this.labelShowArr.push(data)
                      }
                    }
                  }
                }

              }
            }

            console.log(this.formInline,"777")
            this.loading = true
          }
        })
      }
    },
    created () {
      getCityData({}).then(res => {
          if (res.code == "000000") {
            // 格式化职业
            let profession=[],num=1
            this.careersOption = res.data.careers
            for(let item in res.data.careers){
              if(res.data.careers[item].careerSort == num){
                let data ={
                  'label':res.data.careers[item].sortName,
                  'value':res.data.careers[item].careerSort,
                  'children':[]
                }
                for(let index in res.data.careers){
                  if(res.data.careers[index].careerSort == num){
                    res.data.careers[index].value = res.data.careers[index].code
                    res.data.careers[index].label = res.data.careers[index].careerName
                    data.children.push(res.data.careers[index])
                  }
                }
                profession.push(data)
                num ++
              }
            }
            //职业数据
            this.profession = profession;

            //个人标签
            let labelLocal=[],num1=1
            this.labelInit = res.data.label
            for(let item in res.data.label){
              if(res.data.label[item].labelsSort == num1){
                let data ={
                  'label':res.data.label[item].sortName,
                  'value':res.data.label[item].labelsSort,
                  'children':[]
                }
                for(let index in res.data.label){
                  if(res.data.label[index].labelsSort == num1){
                    res.data.label[index].value = res.data.label[index].code
                    res.data.label[index].label = res.data.label[index].labelsName
                    data.children.push(res.data.label[index])
                  }
                }
                labelLocal.push(data)
                num1 ++
              }
            }
            this.labelArr = labelLocal

            //情感数据
            this.emotion = res.data.affection;            
            //星座数据
            this.constellation = res.data.constellation;
            //语言能力
            this.languageArr = res.data.language
            //城市数据
            this.result = res.data.result;
            //格式化城市
            let province = [];
            for(let pro of res.data.result){
              let city = [];
              let ss = {
                'value':pro.id,
                'label':pro.areaname,
                'children':city
              }
              province.push(ss);
              for(let cit of pro.result){
                let area = [];
                let s = {
                  'value':cit.id,
                  'label':cit.areaname,
                  'children':area
                }
                city.push(s);
                for(let are of cit.result){
                  let q = {
                    'value':are.id,
                    'label':are.areaname,
                    'children':[]
                  }
                  area.push(q)
                } 
              }
            }

            this.hometown = province;
            this.hometownNow = province;


            this.$nextTick(() => {
              //个人信息获取
              this.getUserInfor()
            })

          }else{
            layer.open({content: res.msg,skin: 'msg',time: 3});
          }
        }
      );
    }
  }
</script>
<style lang="scss" scoped>
    @import '../../../src/scss/commonH5.scss';

    /* 基本资料 */
    .avatar{
      height: 100px;
      width: 100px;
      border-radius: 50%;
      border: 1px solid #d6d6d6;
    }
    .bar_blog .dashed {
      border-bottom: 1px dashed #F1F1F1;
      padding-bottom: 20px;
      margin-bottom: 25px;
    }
    .bar_blog .title1 {
      font-size: 18px;
      color: #333;
    }
    .bar_blog .title1::before {
      content: '';
      display: inline-block;
      width: 5px;
      height: 27px;
      border-radius: 5px;
      vertical-align: bottom;
      background-color: #F16202;
      margin-right: 20px;
    }
    .bar_blog .title2, .bar_blog .title2 em {
      text-align: right;
      font-size: 14px;
      color: #959595;
      line-height: 27px;
    }
    .bar_blog .repeatable {
      padding-bottom: 20px;
    }
    .bar_blog .repeatable .name {
      font-size: 14px;
      text-align: right;
      line-height: 40px;
    }
    .bar_blog .repeatable .in input {
      color: #F16202
    }
    .el-border{
      border-radius: 50%;
      width: 100px;
      height: 100px;
      line-height: 100px;
      border: 1px solid #ddd;
      text-align: center;
    }
    .bar_blog .repeatable .sex {
      line-height: 40px;
      padding-left: 10px;
    }

    .name_money{
      padding: 20px 80px;
      border: 1px solid #d5d5d5;
      span{
        color: #f60;
      }
    }

    /* // 城市选择*/
    .city .el-select {
      width: 130px;
      margin-right: 5px;
    }
    /*//保存*/
    .repeatable .el-col-24 {
      text-align: center;
      margin-top: 10px;
    }

    .personal-money-tip{
      font-size: 24px;
    }
    .personal-money{
      font-size: 56px;
      font-weight: bold;
    }
    .personal-money-btn{
      color: #fff !important;
      background: #698adb;
      padding: 16px 50px;
      border-radius: 10px;
      font-size: 18px;
    }
    .personal-money-btm-tip{
      color: #999 !important;
      float: right;
      margin-top: -20px;
      margin-right: 30px;
    }
    .personal-money-one{
      color: #fff !important;
      background: #698adb;
      padding: 6px 30px;
      border-radius: 10px;
      font-size: 16px;
      margin-top: 24px;
    }
    .personal-money-two{
      color: #fff !important;
      background: #26b3f4;
      padding: 6px 30px;
      border-radius: 10px;
      font-size: 16px;
      margin-top: 24px;
      margin-right: 20px;
    }


    /*// 英语能力*/
    .language_competence {
      .entrance {
        color: #f60;
        width: 130px;
        margin-right: 5px;
        border: 1px solid #f60;
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        margin-bottom: 20px;
        position: relative;
        padding: 10px;
      }
      .entrance-border{
        position: absolute;
        top: -16px;
        right: -17px;
        width: 0;
        height: 0;
        overflow: hidden;
        color: #fff;
        font-size: 0;
        line-height: 0;
        border-width: 16px;
        border-style: solid dashed dashed dashed;
        border-color: transparent #f60 transparent transparent;
        transform: rotate(136deg);
        -ms-transform: rotate(136deg);
        -moz-transform: rotate(136deg);
        -webkit-transform: rotate(136deg);
        -o-transform: rotate(136deg); 
        z-index: 0;
        cursor: pointer;
      }
      .entrance-close{
        color: #fff;
        z-index: 1;
        position: absolute;
        top: -2px;
        right: 2px;
        cursor: pointer;
      }
    }
</style>



// WEBPACK FOOTER //
// src/views/home/authInfor.vue